import { useQuery, UseQueryResult } from 'react-query';
import ContentService from 'utils/contentful/contentfulService';

interface TherapistReview {
  score: number;
  reviewCount: number;
}

export const useContentfulTherapistAverageScore = (
  therapistName: string,
): UseQueryResult<TherapistReview | undefined, unknown> => {
  return useQuery(['contentful-therapistReview', therapistName], async () => {
    const therapistReviews = await ContentService.clients.marketing.getEntries({
      content_type: 'therapistReview',
      'fields.therapist.sys.contentType.sys.id': 'therapist',
      'fields.therapist.fields.name': therapistName,
      select: ['fields.score'],
    });

    if (therapistReviews.items.length === 0) return undefined;

    const totalScore = therapistReviews.items.reduce((sum, review) => {
      return sum + review.fields.score;
    }, 0);

    const averageScore = totalScore / therapistReviews.items.length;

    const result: TherapistReview = {
      score: averageScore,
      reviewCount: therapistReviews.items.length,
    };

    return result;
  });
};
